/* Forum Yuva – JS (Shopify customer login, robuste)
   - Boutons actifs même si Supabase tarde
   - Connexion via comptes clients Shopify (pas d’auth Supabase)
   - user_id = customer.id, pseudo dans table profiles
*/
(function init() {
  const root = document.getElementById('forum-yuva');
  if (!root) return setTimeout(init, 200);

  // ---- Config Shopify + Supabase
  const SUPABASE_URL = (root.dataset.supabaseUrl || '').trim();
  const SUPABASE_ANON = (root.dataset.supabaseKey || '').trim();
  const HAS_CONFIG = !!(SUPABASE_URL && SUPABASE_ANON);

  const SHOPIFY = {
    loggedIn: root.dataset.loggedIn === 'true',
    id: root.dataset.customerId || null,
    email: root.dataset.customerEmail || null,
    name: root.dataset.customerName || null
  };

  // ---- DOM
  const el = {
    cats: document.getElementById('fy-categories'),
    search: document.getElementById('fy-search'),
    list: document.getElementById('fy-threads'),
    count: document.getElementById('fy-count'),
    activeCat: document.getElementById('fy-active-cat'),
    modal: document.getElementById('fy-modal'),
    loginBtn: document.getElementById('fy-login-btn'),
    newBtn: document.getElementById('fy-new-thread-btn'),
    suggestBtn: document.getElementById('fy-suggest-cat-btn'),
    recent: document.getElementById('fy-recent-threads')
  };

  // Met la modale directement sous <body> (z-index sûr)
  if (el.modal && el.modal.parentNode !== document.body) {
    document.body.appendChild(el.modal);
  }

  // ---- État
  const state = { categories: [], activeCat: null, threads: [], search: '' };

  // ---- Bouton "Se connecter" TOUJOURS fonctionnel
  if (el.loginBtn) {
    el.loginBtn.textContent = SHOPIFY.loggedIn ? 'Mon profil' : 'Se connecter';
    el.loginBtn.onclick = () => {
      if (SHOPIFY.loggedIn) location.href = '/account';
      else {
        const ret = encodeURIComponent(location.pathname + location.search);
        location.href = `/account/login?return_url=${ret}`;
      }
    };
  }

  // ---- Bouton "Nouveau sujet" TOUJOURS attaché
  if (el.newBtn) {
    el.newBtn.onclick = () => {
      if (!HAS_CONFIG) { alert('Le forum n’est pas configuré : renseigne Supabase URL & ANON KEY dans la section.'); return; }
      if (!window.supabase) { alert('Le script Supabase n’a pas chargé. Recharge la page (Ctrl/Cmd+Shift+R).'); return; }
      if (!window.fyClient) { alert('Le forum n’est pas encore prêt. Réessaie dans 1 seconde.'); return; }
      window.__fyOpenNewThread?.();
    };
  }

  // ---- Si Supabase n’est pas configuré : on s’arrête ici (UI informative)
  if (!HAS_CONFIG) {
    showInfo('Le forum n’est pas encore configuré. Renseigne <strong>Supabase URL</strong> et <strong>ANON KEY</strong> dans les paramètres de la section.');
    return;
  }

  // ---- Attendre la lib Supabase si besoin
  if (!window.supabase) return setTimeout(init, 200);

  // ---------- Client Supabase
  const client = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON);
  window.fyClient = client;
  console.log('[Forum Yuva] Supabase prêt');

  // ---------- UI bindings restants
  if (el.search) {
    el.search.addEventListener('input', debounce((e) => {
      state.search = e.target.value;
      loadThreads();
    }, 300)); // 300ms après la dernière frappe
  }
  if (el.suggestBtn) el.suggestBtn.onclick = openSuggestCategory;


  // ---------- Boot data
  boot();

  // Création auto du profil à la connexion Shopify
  if (SHOPIFY.loggedIn && SHOPIFY.id) {
    ensureProfile();
  }

  async function boot() {
    await loadCategories();
    await loadThreads();
    loadRecentThreads();
  }

  function showInfo(html) {
    const card = document.createElement('div');
    card.className = 'fy-card';
    card.innerHTML = `<div class="fy-card-head"><strong>Forum</strong></div>
      <div style="padding:12px 16px">${html}</div>`;
    const wrapper = root.querySelector('.forum-yuva.container');
    if (wrapper) wrapper.appendChild(card); else root.appendChild(card);
  }

  // ---------- Data
  async function loadCategories() {
    try {
      const { data, error } = await window.fyClient.from('categories').select('*').order('name');
      if (error) throw error;

      state.categories = data || [];
      state.activeCat = state.activeCat || state.categories[0] || null;

      // (re)dessine les boutons catégories avec gestion du "sélectionné"
      if (el.cats) {
        el.cats.innerHTML = '';
        state.categories.forEach((c) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = `fy-btn${(state.activeCat && state.activeCat.id === c.id) ? ' fy-primary' : ''}`;
          b.textContent = c.name;

          b.addEventListener('click', () => {
            // 1) met à jour l'état
            state.activeCat = c;
            if (el.activeCat) el.activeCat.textContent = c.name;

            // 2) met à jour le style : un seul bouton actif
            el.cats.querySelectorAll('button').forEach(btn => btn.classList.remove('fy-primary'));
            b.classList.add('fy-primary');

            // 3) recharge les sujets
            loadThreads();
          });

          el.cats.appendChild(b);
        });
      }

      if (el.activeCat) el.activeCat.textContent = state.activeCat ? state.activeCat.name : 'Catégorie';
    } catch (e) {
      console.error('[Forum Yuva] Erreur loadCategories:', e);
    }
  }

  async function loadRecentThreads() {
    if (!window.fyClient || !el.recent) return;
    try {
      const { data, error } = await window.fyClient
        .from('threads')
        .select('id,title,created_at')
        .order('created_at', { ascending: false })
        .limit(6);
      if (error) throw error;

      if (!data || !data.length) {
        el.recent.innerHTML = '<li>Aucun sujet pour le moment.</li>';
        return;
      }
      el.recent.innerHTML = '';
      data.forEach(t => {
        const li = document.createElement('li');
        li.innerHTML = `
          <a href="javascript:void(0)">${escapeHTML(t.title)}</a>
          <div class="fy-news-meta">${new Date(t.created_at).toLocaleDateString()}</div>
        `;
        li.addEventListener('click', () => openThread(t.id, t.title));
        el.recent.appendChild(li);
      });
    } catch (e) {
      console.error('[Forum Yuva] Erreur loadRecentThreads:', e);
      el.recent.innerHTML = '<li>Erreur de chargement.</li>';
    }
  }

  function fmtDate(s) { try { return new Date(s).toLocaleString(); } catch (_) { return s; } }
  function escapeHTML(s) { return (s || '').replaceAll('<', '&lt;').replaceAll('>', '&gt;'); }
  function stripHTML(s) { return (s || '').replace(/<[^>]*>/g, ''); }
  function truncate(s, n) { return s.length > n ? `${s.slice(0, n)}…` : s; }

  async function firstPost(threadId) {
    const { data } = await client.from('posts')
      .select('id,content,created_at')
      .eq('thread_id', threadId)
      .order('created_at', { ascending: true })
      .limit(1);
    return (data?.[0]) ? data[0] : null;
  }

  // --- Gestion de version de recherche
  let lastSearchId = 0;

  // --- Fonction utilitaire debounce
  function debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

let currentPage = 1;
const perPage = 10; // nombre de sujets par page

async function loadThreads(page = 1) {
  const searchId = ++lastSearchId;
  if (!el.list) return;
  currentPage = page;

  // Préparation de la requête
  let q = window.fyClient
    .from('threads')
    .select('id,title,created_at,user_id', { count: 'exact' })
    .order('created_at', { ascending: false })
    .range((page - 1) * perPage, page * perPage - 1); // pagination ici

  if (state.activeCat) q = q.eq('category_id', state.activeCat.id);
  if (state.search) q = q.ilike('title', `%${state.search}%`);

  const { data, error, count } = await q;

  // ignore si nouvelle recherche entre-temps
  if (searchId !== lastSearchId) return;

  if (error) {
    console.error('[Forum Yuva] Erreur loadThreads:', error);
    el.list.innerHTML = '<div class="fy-row">Erreur de chargement.</div>';
    return;
  }

  state.threads = data || [];
  const totalCount = count || 0;
  const totalPages = Math.ceil(totalCount / perPage);

  if (el.count) {
    el.count.textContent = `${totalCount} sujet${totalCount > 1 ? 's' : ''}`;
  }

  el.list.innerHTML = '';
  if (state.threads.length === 0) {
    el.list.innerHTML = '<div class="fy-row">Aucun sujet pour le moment. Lance la discussion !</div>';
    return;
  }

  // --- Affichage des sujets
  for (const t of state.threads) {
    const row = document.createElement('div');
    row.className = 'fy-row';
    const fp = await firstPost(t.id);
    row.innerHTML = `
      <div class="fy-row-title">${escapeHTML(t.title)}</div>
      <div class="fy-row-meta">${fmtDate(t.created_at)}${fp ? ` — ${truncate(stripHTML(fp.content), 120)}` : ''}</div>
    `;
    row.addEventListener('click', () => openThread(t.id, t.title));
    el.list.appendChild(row);
  }

  // --- Ajout pagination
  const pag = document.createElement('div');
  pag.style.display = 'flex';
  pag.style.justifyContent = 'center';
  pag.style.gap = '8px';
  pag.style.margin = '16px 0';

  const prev = document.createElement('button');
  prev.textContent = '← Précédent';
  prev.className = 'fy-btn';
  prev.disabled = page <= 1;
  prev.onclick = () => loadThreads(page - 1);

  const next = document.createElement('button');
  next.textContent = 'Suivant →';
  next.className = 'fy-btn';
  next.disabled = page >= totalPages;
  next.onclick = () => loadThreads(page + 1);

  const info = document.createElement('span');
  info.textContent = `Page ${page}/${totalPages}`;
  info.style.alignSelf = 'center';

  pag.appendChild(prev);
  pag.appendChild(info);
  pag.appendChild(next);
  el.list.appendChild(pag);
}


  // --- Binding du champ recherche avec debounce
  if (el.search) {
    el.search.addEventListener('input', debounce((e) => {
      state.search = e.target.value;
      loadThreads();
    }, 300));
  }

  function requireLogin() {
    if (SHOPIFY.loggedIn) return true;
    const ret = encodeURIComponent(location.pathname + location.search);
    location.href = `/account/login?return_url=${ret}`;
    return false;
  }

  function modalBox(title) {
    document.documentElement.style.overflow = 'hidden';
    el.modal.classList.remove('hidden'); el.modal.setAttribute('aria-hidden', 'false');
    el.modal.innerHTML = `
      <div class="fy-box">
        <div class="fy-box-head">
          <div>${escapeHTML(title)}</div>
          <button class="fy-btn" id="fy-close">✕</button>
        </div>
        <div class="fy-box-body"></div>
      </div>`;
    el.modal.querySelector('#fy-close').onclick = closeModal;
    return { body: el.modal.querySelector('.fy-box-body') };
  }
  function closeModal() {
    document.documentElement.style.overflow = '';
    el.modal.classList.add('hidden');
    el.modal.setAttribute('aria-hidden', 'true');
    el.modal.innerHTML = '';
  }

  async function ensureProfile() {
    // crée/maj un profil (id = customer.id) pour stocker le pseudo
    if (!SHOPIFY.loggedIn || !SHOPIFY.id) return;
    const pseudoDefault = (SHOPIFY.name || (SHOPIFY.email || '').split('@')[0] || 'Membre');
    await client.from('profiles').upsert(
      { id: SHOPIFY.id, username: pseudoDefault, avatar_url: null },
      { onConflict: 'id' }
    );
  }

  function openNewThread() {
    if (!SHOPIFY.loggedIn || !SHOPIFY.id) {
      const ret = encodeURIComponent(location.pathname + location.search);
      location.href = `/account/login?return_url=${ret}`;
      return;
    }

    const box = modalBox('Nouveau sujet');
    box.body.innerHTML = `
      <label>Catégorie</label>
      <select id="fy-cat" class="fy-input" style="margin:6px 0 10px"></select>
      <label>Titre</label>
      <input id="fy-title" class="fy-input" placeholder="Sujet de la discussion" />
      <label>Message</label>
      <textarea id="fy-msg" class="fy-textarea" placeholder="Écris ton message…"></textarea>
      <div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px">
        <button class="fy-btn" id="fy-cancel">Annuler</button>
        <button class="fy-btn fy-primary" id="fy-publish">Publier</button>
      </div>
    `;


    // remplir catégories
    const sel = box.body.querySelector('#fy-cat');
    state.categories.forEach(c => {
      const o = document.createElement('option'); o.value = c.id; o.textContent = c.name; sel.appendChild(o);
    });
    sel.value = state.activeCat?.id || state.categories[0]?.id;

    box.body.querySelector('#fy-cancel').onclick = closeModal;
    box.body.querySelector('#fy-publish').onclick = async () => {
      const title = box.body.querySelector('#fy-title').value.trim();
      const content = box.body.querySelector('#fy-msg').value.trim();
      const cat = sel.value;

      if (!title || !cat) { alert('Titre et catégorie requis.'); return; }

      try {
        // 1) profil (silencieux)
        try {
          const pseudoDefault = (SHOPIFY.name || (SHOPIFY.email || '').split('@')[0] || 'Membre');
          await window.fyClient.from('profiles').upsert(
            { id: SHOPIFY.id, username: pseudoDefault, avatar_url: null },
            { onConflict: 'id' }
          );
        } catch (e) { console.warn('Upsert profile (non bloquant):', e); }

        // 2) thread
        const tRes = await window.fyClient
          .from('threads')
          .insert({ title, category_id: cat, user_id: SHOPIFY.id })
          .select('id')
          .single();

        if (tRes.error) {
          console.error('Insert threads error:', tRes.error);
          alert(`Erreur création sujet : ${tRes.error.message || JSON.stringify(tRes.error)}`);
          return;
        }

        // 3) premier post
        const pRes = await window.fyClient
          .from('posts')
          .insert({ thread_id: tRes.data.id, user_id: SHOPIFY.id, content })
          .select('id')
          .single();

        if (pRes.error) {
          console.error('Insert post error:', pRes.error);
          alert(`Sujet créé mais erreur sur le message : ${pRes.error.message || JSON.stringify(pRes.error)}`);
        }

        closeModal();
        await loadThreads();
        if (typeof loadRecentThreads === 'function') loadRecentThreads(); // maj sidebar
        openThread(tRes.data.id, title);
      } catch (e) {
        console.error('[Forum Yuva] Exception création sujet:', e);
        alert(`Erreur inattendue : ${e?.message || e}`);
      }
    };
  }

  async function openThread(threadId, title) {
    const box = modalBox(title || 'Discussion');
    box.body.innerHTML = `
      <div id="fy-posts"></div>
      <div style="margin-top:12px">
        <textarea id="fy-reply" class="fy-textarea" placeholder="Ta réponse…"></textarea>
        <div style="display:flex;justify-content:flex-end;margin-top:8px;align-items:center">
          <button class="fy-btn-text" id="fy-report-thread" style="font-size:13px;color:#9ca3af;background:none;border:none;padding:0;margin-right:auto">Signaler ce fil</button>
          <button class="fy-btn fy-primary" id="fy-send">Envoyer</button>
        </div>
      </div>`;
    const postsEl = box.body.querySelector('#fy-posts');
    await renderPosts(postsEl, threadId);

    // Bouton signalement thread (plus discret)
    box.body.querySelector('#fy-report-thread').onclick = () => {
      openReportModal('thread', threadId);
    };

    box.body.querySelector('#fy-send').onclick = async () => {
      if (!requireLogin()) return;
      const msg = box.body.querySelector('#fy-reply').value.trim();
      if (!msg) return;
      try {
        await ensureProfile();
        const { data, error } = await client.from('posts')
          .insert({ thread_id: threadId, user_id: SHOPIFY.id, content: msg })
          .select('*')
          .single();
        if (error) throw error;
        addPost(postsEl, data);
        box.body.querySelector('#fy-reply').value = '';
      } catch (e) {
        console.error('[Forum Yuva] Erreur envoi post:', e);
        alert('Erreur lors de l’envoi du message.');
      }
    };
  }

  async function renderPosts(container, threadId) {
    try {
      const { data, error } = await client.from('posts')
        .select('id,content,created_at,like_count,user_id,thread_id')
        .eq('thread_id', threadId)
        .order('created_at', { ascending: true });
      if (error) throw error;
      container.innerHTML = '';
      (data || []).forEach(p => addPost(container, p));
    } catch (e) {
      console.error('[Forum Yuva] Erreur chargement posts:', e);
      container.innerHTML = 'Erreur de chargement des messages.';
    }
  }

  function addPost(container, p) {
    const row = document.createElement('div');
    row.className = 'fy-row';
    row.innerHTML = `
    <div class="fy-row-meta">${fmtDate(p.created_at)}</div>
    <div style="white-space:pre-wrap;margin:6px 0">${escapeHTML(p.content)}</div>
    <div style="display:flex;justify-content:space-between;align-items:center;gap:8px">
      <button class="fy-like" data-id="${p.id}">👍 ${p.like_count || 0}</button>
      <button class="fy-report fy-btn" data-id="${p.id}" style="margin-left:auto;">Signaler</button>
    </div>
  `;
    row.querySelector('.fy-like').onclick = async (e) => {
      const id = e.currentTarget.getAttribute('data-id');
      try {
        const { data, error } = await window.fyClient.from('posts')
          .update({ like_count: (p.like_count || 0) + 1 })
          .eq('id', id)
          .select('like_count')
          .single();
        if (!error) { e.currentTarget.textContent = `👍 ${data.like_count}`; p.like_count = data.like_count; }
      } catch (_) { }
    };

    // Bouton signaler : ouvre la modale UX
    const rptBtn = row.querySelector('.fy-report');
    rptBtn.onclick = () => {
      openReportModal('post', p.id, p.thread_id);
    };

    container.appendChild(row);
  }


  function openSuggestCategory() {
    if (!SHOPIFY.loggedIn) { requireLogin(); return; }
    const box = modalBox('Suggérer une catégorie');
    box.body.innerHTML = `
      <label>Nom de la catégorie</label>
      <input id="fy-sugg-name" class="fy-input" placeholder="ex: Bons plans locaux" />
      <label>Pourquoi ? (optionnel)</label>
      <textarea id="fy-sugg-reason" class="fy-textarea" placeholder="Explique en 1-2 phrases…"></textarea>
      <div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px">
        <button class="fy-btn" id="fy-cancel">Annuler</button>
        <button class="fy-btn fy-primary" id="fy-send">Envoyer</button>
      </div>
    `;
    box.body.querySelector('#fy-cancel').onclick = closeModal;
    box.body.querySelector('#fy-send').onclick = async () => {
      const name = box.body.querySelector('#fy-sugg-name').value.trim();
      const reason = box.body.querySelector('#fy-sugg-reason').value.trim();
      if (!name) { alert('Nom requis.'); return; }
      await window.fyClient.from('category_suggestions').insert({
        name, reason, user_id: SHOPIFY.id, user_email: SHOPIFY.email
      });
      box.body.innerHTML = `<p>Merci ! Ta suggestion a été envoyée. Elle sera examinée rapidement.</p>
        <div style="display:flex;justify-content:flex-end;margin-top:10px">
          <button class="fy-btn fy-primary" id="fy-close-ok">OK</button>
        </div>`;
      box.body.querySelector('#fy-close-ok').onclick = closeModal;
    };
  }

  // ----- Exposer pour l'UI/console
  window.__fyOpenNewThread = openNewThread;     // bouton "Nouveau sujet"
  window.__fyLoadThreads = loadThreads;        // console: __fyLoadThreads()
  window.__fyLoadCategories = loadCategories;     // console: __fyLoadCategories()
  window.__fyLoadRecentThreads = loadRecentThreads;  // console: __fyLoadRecentThreads()
  window.__fyOpenThread = openThread;         // console: __fyOpenThread(id,'Titre')

  // async function uploadFile(file, threadId, opts = {}) {
  //   // opts: { fnUrl, accessToken, captchaWidgetId, maxSize }
  //   const fnUrl = opts.fnUrl || root.dataset.uploadFn || root.dataset.uploadFnUrl
  //   const accessToken = opts.accessToken || root.dataset.uploadToken || root.dataset.supabaseAccessToken || null;
  //   const widgetId = typeof opts.captchaWidgetId !== 'undefined' ? opts.captchaWidgetId : (window.__fyCaptchaWidgetId || null);
  //   const maxSize = opts.maxSize || 5 * 1024 * 1024; // 5MB par défaut

  //   if (!file) throw new Error('Aucun fichier fourni');

  //   // validation client-side (type + taille)
  //   const allowed = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  //   if (file.size > maxSize) throw new Error('Le fichier est trop volumineux (max 5MB)');
  //   if (allowed.indexOf(file.type) === -1) throw new Error('Type de fichier non supporté');

  //   // obtention du token captcha si possible
  //   let captchaToken = null;
  //   try {
  //     if (window.hcaptcha && typeof window.hcaptcha.execute === 'function' && widgetId != null) {
  //       try { captchaToken = await window.hcaptcha.execute(widgetId, { async: true }); } catch (e) { console.warn('hCaptcha execute failed:', e); }
  //     } else if (window.hcaptcha && typeof window.hcaptcha.execute === 'function') {
  //       // widgetId absent: attempt to execute without id (may fail)
  //       try { captchaToken = await window.hcaptcha.execute(); } catch (e) { console.warn('hCaptcha execute (no widgetId) failed:', e); }
  //     }
  //   } catch (e) { console.warn('captcha check error:', e); }

  //   const fd = new FormData();
  //   fd.append('file', file);
  //   if (threadId) fd.append('thread_id', threadId);
  //   if (SHOPIFY.id) fd.append('uploaded_by', SHOPIFY.id);
  //   if (captchaToken) fd.append('captcha', captchaToken);

  //   const headers = {};
  //   if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  //   const res = await fetch(fnUrl, { method: 'POST', body: fd, headers });

  //   // tenter de parser JSON, gérer erreurs
  //   let json;
  //   const text = await res.text();
  //   try { json = text ? JSON.parse(text) : {}; } catch { throw new Error(`Réponse invalide du serveur: ${text}`); }

  //   if (!res.ok) {
  //     const err = json?.error || json?.message || `Upload failed (${res.status})`;
  //     throw new Error(err);
  //   }

  //   if (!json || (!json.ok && !json.attachment && !json.url)) {
  //     throw new Error(json?.error || json?.message || 'Upload: réponse inattendue');
  //   }

  //   return json; // { ok: true, attachment: {...}, url: 'https://...' }
  // }

  // expose upload helper
  // window.__fyUploadFile = uploadFile;

  // À placer AVANT addPost et openThread
  function openReportModal(contentType, contentId, threadId = null) {
    const box = modalBox('Signaler un contenu');
    box.body.innerHTML = `
    <label>Motif du signalement</label>
    <textarea id="fy-report-reason" class="fy-textarea" placeholder="Explique brièvement pourquoi ce contenu est inapproprié…"></textarea>
    <div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px">
      <button class="fy-btn" id="fy-cancel-report">Annuler</button>
      <button class="fy-btn fy-primary" id="fy-submit-report">Envoyer</button>
    </div>
  `;
    box.body.querySelector('#fy-cancel-report').onclick = closeModal;
    box.body.querySelector('#fy-submit-report').onclick = async () => {
      const reason = box.body.querySelector('#fy-report-reason').value.trim();
      if (!reason) {
        alert('Merci de préciser un motif.');
        return;
      }
      try {
        const payload = {
          reason,
          reporter_id: SHOPIFY.loggedIn ? SHOPIFY.id : null,
        };
        if (contentType === 'post') {
          payload.post_id = contentId;
          payload.thread_id = threadId;
        }
        if (contentType === 'thread') {
          payload.thread_id = contentId;
        }
        const { error } = await window.fyClient.from('reports').insert(payload);
        if (error) throw error;
        alert('Signalement envoyé, merci.');
        closeModal();
      } catch (e) {
        alert('Erreur lors de l\'envoi du signalement.');
        closeModal();
      }
    };
  }
})();